import { useState, useEffect } from 'react';
import { FullJoints, Xray } from 'models/XrayModels';
import { PRO } from 'models/SurveyModels';
import { Appointment } from 'models/AppointmentModels';
import { RequiredViews } from 'hooks/useAppointmentJointViewsData';
import { Patient } from 'models/PatientModels';
import { ENDPOINT_BASE_URL } from 'hooks/constants';
import HttpService from 'services/httpService';

type AppointmentRequiredJointViews = Record<FullJoints, RequiredViews>;

export interface DemoDataResponse {
  patient: Patient;
  appointment: Appointment;
  xraysMappedToJoints: Record<FullJoints, Xray[]>;
  latestProsMappedToJoints: Record<FullJoints, PRO>;
  roiImgUrls: Record<string, string>;
  appointmentRequiredJointViews: AppointmentRequiredJointViews;
}

export type DemoData = {
  isLoading: boolean;
  error?: Error | null
  data?: DemoDataResponse | null;
};

export const useDemoExamRoomData = (patientName?: string | null): DemoData => {
  const [isLoading, setIsLoading] = useState(true);
  const [demoData, setDemoData] = useState<DemoDataResponse>();
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchDemoData = async () => {
      try {
        setIsLoading(true);

        const response = await HttpService.get<DemoDataResponse>({
          url: `${ENDPOINT_BASE_URL}/demo/${patientName || "betsy_davis"}`,
          token: null,
        });

        setDemoData(response.data);
      } catch (err) {
        console.error("Error fetching demo data:", err);
        setError(
          err instanceof Error ? err : new Error("Failed to fetch demo data")
        );
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
    };

    fetchDemoData();
  }, [patientName]);

  return {
    data: demoData,
    isLoading,
    error
  };
}; 